module.exports = __webpack_public_path__ + "media/asset/images/AndoHazama/ITRI_company_resource_AndoHazama-3477e6a5b979f54c7605cf4268dcc404.png";